import { render, staticRenderFns } from "./TikTokFeed.vue?vue&type=template&id=799000af&"
import script from "./TikTokFeed.vue?vue&type=script&lang=js&"
export * from "./TikTokFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoursesTikTokAlt: require('/opt/build/repo/components/Courses/TikTokAlt.vue').default})
